import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../services/api';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }
    if (password.length < 8) {
      setError('Le mot de passe doit contenir au moins 8 caractères');
      return;
    }

    setSubmitting(true);
    try {
      await api.post('/auth/password/reset', { token, password });
      setDone(true);
    } catch (err) {
      setError(err.message || 'Une erreur est survenue');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center th-bg px-4 transition-colors duration-300">
      <div className="w-full max-w-sm animate-fadeInUp">
        <div className="text-center mb-8">
          <Link to="/" className="font-mono font-bold text-2xl text-accent tracking-[0.15em]">STRIDERR</Link>
          <p className="mt-2 text-sm th-text-secondary">Nouveau mot de passe</p>
        </div>

        {!token ? (
          <div className="border th-border p-6 th-bg-surface transition-colors duration-300 space-y-4">
            <p className="text-sm th-text">Lien invalide ou expiré.</p>
            <Link to="/forgot-password" className="text-accent hover:opacity-70 transition-opacity duration-150 font-mono text-sm">
              Demander un nouveau lien
            </Link>
          </div>
        ) : done ? (
          <div className="border th-border p-6 th-bg-surface transition-colors duration-300 space-y-4">
            <p className="text-sm th-text">Mot de passe réinitialisé avec succès.</p>
            <Link to="/login" className="text-accent hover:opacity-70 transition-opacity duration-150 font-mono text-sm">
              Se connecter
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="border th-border p-6 space-y-6 th-bg-surface transition-colors duration-300">
            {error && (
              <div className="border border-status-rejected/30 text-status-rejected px-3 py-2 text-sm font-mono">
                {error}
              </div>
            )}

            <div>
              <label htmlFor="password" className="block text-xs font-mono th-text-secondary mb-2 uppercase tracking-widest">
                Nouveau mot de passe
              </label>
              <input
                id="password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="th-input"
                placeholder="••••••••"
              />
            </div>

            <div>
              <label htmlFor="confirmPassword" className="block text-xs font-mono th-text-secondary mb-2 uppercase tracking-widest">
                Confirmer le mot de passe
              </label>
              <input
                id="confirmPassword"
                type="password"
                required
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="th-input"
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              disabled={submitting}
              className="w-full th-btn-accent"
            >
              {submitting ? 'Réinitialisation...' : 'Réinitialiser'}
            </button>
          </form>
        )}

        <p className="text-center mt-6 text-sm th-text-muted">
          <Link to="/login" className="text-accent hover:opacity-70 transition-opacity duration-150 font-mono">
            Retour à la connexion
          </Link>
        </p>
      </div>
    </div>
  );
}
